import { Badge, Card, CardContent, CardHeader, CardTitle } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconBulb } from "@tabler/icons-react";
import { ColorTagsWithInfo } from "@/components/tags";
import type { WarehouseDetails } from "@/pages/warehouse/types";
import HeadingWithIcon from "@/components/icon/HeadingWithIcon";

interface WarehouseInsightsProps {
  warehouseDetails: WarehouseDetails;
}

const WarehouseInsights = ({ warehouseDetails }: WarehouseInsightsProps) => {
  if (!warehouseDetails.tags.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Stack direction="row" align="center">
            <HeadingWithIcon icon={IconBulb} title="Insights" />
            <Badge className="hover:!al-bg-[#ffeae4] !al-cursor-default" variant={"warning"}>
              {warehouseDetails.tags.length}
            </Badge>
          </Stack>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ColorTagsWithInfo tags={warehouseDetails.tags} />
      </CardContent>
    </Card>
  );
};

export default WarehouseInsights;
